import { render, staticRenderFns } from "./DynamicTabsContainer.vue?vue&type=template&id=69b32a18&"
import script from "./DynamicTabsContainer.vue?vue&type=script&lang=js&"
export * from "./DynamicTabsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69b32a18')) {
      api.createRecord('69b32a18', component.options)
    } else {
      api.reload('69b32a18', component.options)
    }
    module.hot.accept("./DynamicTabsContainer.vue?vue&type=template&id=69b32a18&", function () {
      api.rerender('69b32a18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/DynamicTabsContainer.vue"
export default component.exports